/* eslint no-template-curly-in-string: off */

const urlConf = {
  home: { // homepage
    uri: '/',
    host: 'appHost'
  },
  error: { // error
    uri: '/error?code=${code}',
    host: 'appHost'
  },
  sellerDashboard: {
    uri: '/seller/dashboard',
    host: 'appHost'
  },
  sellerRefreshSeCookie: {
    uri: '/seller/login?sellerId=${sellerId}',
    host: 'appHost'
  },
  refreshOkta: {
    uri: '/refreshokta?.done=${dotDoneUrl}'
  },
  login: {
    uri: '/ServiceLogin.aspx',
    host: 'scmHost.external'
  },
  supplierRanking: {
    uri: '/SupplierRanking/MonthlySupplierRankingResult.aspx',
    host: 'scmHost'
  },
  moreAnnouncements: {
    uri: '/Misc/PLTQuery.aspx',
    host: 'scmHost'
  },
  ot371: {
    uri: '/371',
    host: 'otHost'
  },
  sellerSimulateLogin: {
    uri: '/se',
    host: 'otHost'
  },
  sellerSimulateLoginWithId: {
    uri: '/se?sellerId=${sellerId}',
    host: 'otHost'
  },
  sellerLogin: {
    uri: '/store_admin/view/login',
    host: 'sellerHost'
  },
  sellerAdmin: {
    uri: '/store_admin/view/home',
    host: 'sellerHost'
  },
  scmHomepage: {
    uri: '/',
    host: 'scmHost'
  },
  scmLogout: {
    uri: '/SCMLogout.ashx',
    host: 'scmHost.external'
  },
  scmStockQtyAdjust: {
    uri: '/GdStock/StockQtyAdjust.aspx',
    host: 'scmHost'
  },
  scmProductCostPrice: {
    uri: '/SupplierProposal/Product/UpdateProductCostPrice01.aspx',
    host: 'scmHost'
  },
  scmNewListingProposal: {
    uri: '/SupplierProposal/Product/NewItemStep1.aspx',
    host: 'scmHost'
  },
  scmNewProductProposal: {
    uri: '/SupplierProposal/Product/NewProductStep1.aspx',
    host: 'scmHost'
  },
  scmUpdateImage: {
    uri: '/SupplierProposal/Product/ChangeItemPhotosStep1.aspx',
    host: 'scmHost'
  },
  scmUpdateCopyProposal: {
    uri: '/supplierProposal/Product/ProductSpecialContentQuery.aspx',
    host: 'scmHost'
  },
  scmProposalQuery: {
    uri: '/SupplierProposal/ProposalQuery.aspx',
    host: 'scmHost'
  },
  scmPMPortal: {
    uri: '/PMPortal.aspx',
    host: 'scmHost'
  },
  scmProposalLookup: {
    uri: '/SCM20_Internal/InternalLogin.aspx',
    host: 'erpHost'
  },
  scmQueryCampaign: {
    uri: '/SCM20/Query/QueryCampaign.aspx',
    host: 'scmHost'
  },
  scmCreateInventory: {
    uri: '/SCM20/Inventory/CreateInventory.aspx',
    host: 'scmHost'
  },
  scmApiKeyIntroduction: { // 批次提案頁 API Key 申請
    uri: '/ApprovalForm/Apply/ApiApplication.aspx',
    host: 'scmHost'
  },
  scmApiKeyQuery: { // 批次提案頁 API Key 查詢
    uri: '/ApprovalForm/Query/ApiKeyQuery.aspx',
    host: 'scmHost'
  },
  buyGdSale: {
    uri: '/gdsale/gdsale.asp',
    host: 'buyHost'
  },
  newListingCompose: { // 新版提案
    uri: '/proposal/newListing/compose',
    host: 'appHost'
  },
  newProductCompose: { // 新版提案
    uri: '/proposal/newProduct/compose',
    host: 'appHost'
  },
  updateCopy: { // 新版修改賣場詳情
    uri: '/listing/query#updateCopy',
    host: 'appHost'
  },
  updateVideo: { // 新版修改賣場影片
    uri: '/listing/query#updateVideo',
    host: 'appHost'
  },
  updateImage: { // 新版修改賣場圖片
    uri: '/listing/query#updateImage',
    host: 'appHost'
  },
  updateAttribute: { // 新版修改賣場規格表
    uri: '/listing/query#updateAttribute',
    host: 'appHost'
  },
  updateListingModel: { // 新版調整賣場屬性項目
    uri: '/listing/query#updateListingModel',
    host: 'appHost'
  },
  updateListing: { // 新版修改賣場資訊
    uri: '/listing/query#updateListing',
    host: 'appHost'
  },
  cloneListing: { // 新版複製賣場
    uri: '/listing/query#cloneListing',
    host: 'appHost'
  }
}

module.exports = urlConf
